// Shared look for the Order Details modal and its tabs (Bouqmark Order Detail
// design, Claude Design 2026-10-01). Cards sit on the ground; their edge is
// border-gray-300, the first border that stays visible on Fable's cream.

export const cardClass = 'flex flex-col gap-3.5 rounded-[1.75rem] border border-gray-300 bg-white px-6 py-[22px]';
export const kickerClass = 'text-[10px] uppercase tracking-[0.1em] text-floral-700';
export const labelClass = 'text-[11px] uppercase tracking-[0.08em] text-gray-600';
export const linkClass = 'font-semibold text-floral-700 no-underline hover:text-floral-800';

// ── Forest Order Detail (design-handoff/forest-theme, Phase 1) ──────────────
// The order page and its tabs use the shared .card / .card-header primitives;
// these are the few type and ink rules they repeat. The classes above stay for
// the other screens that still import them.

// Link ink, matching --f-link: floral-700 in light, floral-900 (#8FC19C) in
// Forest dark, where floral-700 is too dark on the card surface. Written out in
// full so Tailwind's scanner sees the literal class names (as in PageHeader).
export const forestLinkClass =
  'font-medium text-floral-700 no-underline hover:text-floral-800 [html[data-scheme=dark]:not([data-appearance=fable])_&]:text-floral-900 [html[data-scheme=dark]:not([data-appearance=fable])_&]:hover:text-floral-800';

// 11px caps label above a value (Recipient, Address, Verification call…).
export const fieldLabelClass = 'text-[11px] font-semibold uppercase tracking-[0.08em] text-gray-500';

// Tag geometry shared with StatusTag's Forest pill, for stamps that are not an
// order status (Address verified, Not verified). Tone classes go alongside.
export const stampClass = 'inline-flex h-[22px] items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 text-xs font-semibold';

// Time-window tags (README §Phase 0.3): by/before = floral, after/AM/PM =
// neutral, an exact time = danger.
export const windowTagClass = (kind) => {
  const base = 'inline-flex h-5 items-center whitespace-nowrap rounded-md px-2 text-[11px] font-semibold tabular';
  if (kind === 'exact' || kind === 'at') return `${base} bg-danger-bg text-danger-fg`;
  if (kind === 'before' || kind === 'by') return `${base} bg-floral-100 text-floral-900`;
  return `${base} bg-neutral-bg text-neutral-fg`;
};
